import React, { memo } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { getColorOptionForBlock } from '../blockColors';

const OverlayWrapper = styled.div`
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
  border-radius: 4px;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
  cursor: grabbing;
  font-family: 'Nunito Sans', sans-serif;
  font-weight: 700;
  letter-spacing: 0;
  color: ${(props) => props.palette.text};
  overflow: hidden;
  font-size: 16px;
  line-height: 1.5;
  background: ${(props) => props.palette.background};
  box-sizing: border-box;
  border: 2px solid ${(props) => props.palette.accent};
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  opacity: 0.75;
  pointer-events: none;
  will-change: transform;
  transform: translateZ(0);
  backface-visibility: hidden;
`;

const BlockText = styled.div`
  flex: 1;
  text-align: center;
  font-weight: 700;
  line-height: 1.5;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: inherit;
`;

/**
 * Lightweight block preview rendered in DragOverlay portal.
 * Avoids overflow:hidden clipping during drag operations.
 */
const DragOverlayBlock = ({ block, width, height }) => {
  const palette = getColorOptionForBlock(block);

  return (
    <OverlayWrapper
      width={width}
      height={height}
      palette={palette}
    >
      <BlockText>{block.name}</BlockText>
    </OverlayWrapper>
  );
};

DragOverlayBlock.propTypes = {
  block: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string,
    colorId: PropTypes.string,
  }).isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
};

export default memo(DragOverlayBlock);
